"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f117 = void 0;
exports.f117 = {
    "uam": [
        "Latn"
    ],
    "uan": [
        "Zyyy"
    ],
    "uar": [
        "Latn"
    ],
    "uba": [
        "Latn"
    ],
    "ubi": [
        "Latn"
    ],
    "ubl": [
        "Latn"
    ],
    "ubr": [
        "Latn"
    ],
    "ubu": [
        "Latn"
    ],
    "uby": [
        "Cyrl",
        "Latn"
    ],
    "uda": [
        "Latn"
    ],
    "ude": [
        "Cyrl"
    ],
    "udg": [
        "Mlym"
    ],
    "udi": [
        "Cyrl"
    ],
    "udj": [
        "Latn"
    ],
    "udl": [
        "Latn"
    ],
    "udm": [
        "Cyrl",
        "Latn"
    ],
    "udu": [
        "Latn"
    ],
    "ues": [
        "Latn"
    ],
    "ufi": [
        "Latn"
    ],
    "ug": [
        "Arab",
        "Cyrl",
        "Latn"
    ],
    "uga": [
        "Ugar"
    ],
    "ugb": [
        "Latn"
    ],
    "uge": [
        "Latn"
    ],
    "ugn": [
        "Zxxx"
    ],
    "ugo": [
        "Thai"
    ],
    "ugy": [
        "Zxxx"
    ],
    "uha": [
        "Latn"
    ],
    "uhn": [
        "Latn"
    ],
    "uis": [
        "Latn"
    ],
    "uiv": [
        "Latn"
    ],
    "uji": [
        "Latn"
    ],
    "uk": [
        "Cyrl"
    ],
    "uka": [
        "Latn"
    ],
    "ukg": [
        "Latn"
    ],
    "ukh": [
        "Latn"
    ],
    "uki": [
        "Orya"
    ],
    "ukk": [
        "Latn"
    ],
    "ukl": [
        "Zxxx"
    ],
    "ukp": [
        "Latn"
    ],
    "ukq": [
        "Latn"
    ],
    "uks": [
        "Zxxx"
    ],
    "uku": [
        "Latn"
    ],
    "ukw": [
        "Latn"
    ],
    "uky": [
        "Latn"
    ],
    "ula": [
        "Latn"
    ],
    "ulb": [
        "Latn"
    ],
    "ulc": [
        "Cyrl"
    ],
    "ule": [
        "Latn"
    ],
    "ulf": [
        "Latn"
    ],
    "uli": [
        "Latn"
    ],
    "ulk": [
        "Latn"
    ],
    "ull": [
        "Zyyy"
    ],
    "ulm": [
        "Latn"
    ],
    "uln": [
        "Latn"
    ],
    "ulu": [
        "Latn"
    ],
    "ulw": [
        "Latn"
    ],
    "uma": [
        "Latn"
    ],
    "umb": [
        "Latn"
    ],
    "umc": [
        "Ital"
    ],
    "umd": [
        "Latn"
    ],
    "umg": [
        "Latn"
    ],
    "umi": [
        "Latn"
    ],
    "umm": [
        "Latn"
    ],
    "umn": [
        "Latn"
    ],
    "umo": [
        "Latn"
    ],
    "ump": [
        "Latn"
    ],
    "umr": [
        "Latn"
    ],
    "ums": [
        "Latn"
    ],
    "una": [
        "Latn"
    ],
    "und": [
        "Zyyy"
    ],
    "une": [
        "Latn"
    ],
    "ung": [
        "Latn"
    ],
    "uni": [
        "Latn"
    ],
    "unk": [
        "Latn"
    ],
    "unm": [
        "Zyyy"
    ],
    "unn": [
        "Latn"
    ],
    "unr": [
        "Beng",
        "Latn",
        "Deva",
        "Orya"
    ],
    "unu": [
        "Latn"
    ],
    "unx": [
        "Beng",
        "Deva",
        "Orya"
    ],
    "unz": [
        "Latn"
    ],
    "upi": [
        "Latn"
    ],
    "upv": [
        "Latn"
    ],
    "ur": [
        "Arab",
        "Brai",
        "Deva",
        "Latn"
    ],
    "ura": [
        "Latn"
    ],
    "urb": [
        "Latn"
    ],
    "urc": [
        "Latn"
    ],
    "ure": [
        "Latn"
    ],
    "urf": [
        "Latn"
    ],
    "urg": [
        "Latn"
    ],
    "urh": [
        "Latn"
    ],
    "uri": [
        "Latn"
    ],
    "urk": [
        "Thai"
    ],
    "url": [
        "Zyyy"
    ],
    "urm": [
        "Latn"
    ],
    "urn": [
        "Latn"
    ],
    "uro": [
        "Latn"
    ],
    "urp": [
        "Latn"
    ],
    "urr": [
        "Latn"
    ],
    "urt": [
        "Latn"
    ],
    "uru": [
        "Latn"
    ],
    "urv": [
        "Latn"
    ],
    "urw": [
        "Latn"
    ],
    "urx": [
        "Latn"
    ],
    "ury": [
        "Latn"
    ],
    "urz": [
        "Latn"
    ],
    "usa": [
        "Latn"
    ],
    "ush": [
        "Arab"
    ],
    "usi": [
        "Beng",
        "Latn"
    ],
    "usk": [
        "Latn"
    ],
    "usp": [
        "Latn"
    ],
    "uss": [
        "Latn"
    ],
    "usu": [
        "Latn"
    ],
    "uta": [
        "Latn"
    ],
    "ute": [
        "Latn"
    ],
    "uth": [
        "Latn"
    ],
    "utp": [
        "Latn"
    ],
    "utr": [
        "Latn"
    ],
    "utu": [
        "Latn"
    ],
    "uum": [
        "Grek",
        "Cyrl"
    ],
    "uun": [
        "Latn"
    ],
    "uur": [
        "Latn"
    ],
    "uuu": [
        "Zyyy"
    ],
    "uve": [
        "Latn"
    ],
    "uvh": [
        "Latn"
    ],
    "uvl": [
        "Latn"
    ],
    "uwa": [
        "Latn"
    ],
    "uya": [
        "Latn"
    ],
    "uz": [
        "Latn",
        "Arab",
        "Brai",
        "Cyrl",
        "Sogd"
    ],
    "uzs": [
        "Arab"
    ]
};
